import config from 'config';
import { post } from './common';
import log from 'src/logging';

export type Variation = 'A' | 'B' | 'C' | 'D' | 'E';

export async function enrol(slug: string): Promise<Variation> {
  try {
    const response = await post(
      `abtests/${slug}/enrol`,
      {},
      {
        baseUri: config.AB_API_URI,
        withCredentials: true,
        throwOnError: true,
        serverSideTimeout: 2000,
        clientSideTimeout: 2000,
        autoRefreshAccessToken: false,
      }
    );

    return response.body.enrolledIn;
  } catch (err) {
    log.warn({ err }, `Unable to get AB variation for ${slug}.`);
    return 'A';
  }
}



// WEBPACK FOOTER //
// ./src/helpers/api/ab.ts